import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

// this `: unknown` is a hack as primeng doesn't export the type of the Preset<T>
export const preset: unknown = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#f1f9fa',
      100: '#dcf0f1',
      200: '#bde1e4',
      300: '#8fcbd1',
      400: '#6fb7bf',
      500: '#3f919b',
      600: '#377683',
      700: '#32626c',
      800: '#2f515b',
      900: '#2b454e',
      950: '#192d33',
    },
  },
});
